import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const InstructionsStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      justifyContent: "flex-end",
      marginTop: "13px",
    },
    title: {
      color: "#545454",
      fontWeight: theme.typography.fontWeightRegular,
      fontSize: "14px",
    },
    description: {
      color: "#545454",
      fontWeight: theme.typography.fontWeightRegular,
      fontSize: "19px",
      paddingTop: "10px",
      [theme.breakpoints.up("md")]: {
        fontSize: "16px",
        lineSpacing: "19px",
      },
    },
    link: {
      fontWeight: theme.typography.fontWeightMedium,
      margin: 0,
      color: "#fc4c4c",
      fontSize: "1rem",
      lineHeight: 1.5,
      [theme.breakpoints.up("md")]: {
        fontSize: "16px",
        lineSpacing: "19px",
      },
    },
  }),
);
